module.exports = __webpack_public_path__ + "static/media/logo-header.79f049c3.svg";